
export const formatDate = (isoString: string): string => {
    // Format date to DD/MM/YYYY
    const date = new Date(isoString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
};

export const formatDateForAPI = (date: Date): string => {
    // Format date to YYYY-MM-DD
    return date.toISOString().split('T')[0]
};

export const formatDateTime = (isoString: string): string => {
    // Format date to DD/MM/YYYY HH:MM
    const date = new Date(isoString);
    const dateTimeStr= Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: "short"
    }).format(date);
    return `${dateTimeStr}`
};
